module.exports = {"410204001":"相国寺街道","410204002":"新华街道","410204003":"卧龙街道","410204004":"州桥街道","410204005":"西司门街道","410204006":"南苑街道","410204007":"五一街道","410204008":"仙人庄街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410204.json
// module id = 1530
// module chunks = 0